const SHIFTS = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21];
const CONSTANTS = Array.from(
  { length: 64 },
  (_, i) => Math.floor(Math.abs(Math.sin(i + 1)) * 2 ** 32) >>> 0,
);

/**
 * The MD5 of a string's UTF-8 bytes, which the 3tz index is keyed by. WebCrypto has no MD5, and
 * only a few short paths are ever hashed.
 */
export function md5(input: string): Uint8Array {
  const bytes = new TextEncoder().encode(input);
  // The bytes, a 1 bit, zeros and the bit length as a u64, in 64-byte blocks
  const blockCount = ((bytes.length + 8) >> 6) + 1;
  const words = new Uint32Array(blockCount * 16);
  bytes.forEach((byte, i) => {
    words[i >> 2] |= byte << ((i % 4) * 8);
  });
  words[bytes.length >> 2] |= 0x80 << ((bytes.length % 4) * 8);
  words[blockCount * 16 - 2] = (bytes.length * 8) >>> 0;
  words[blockCount * 16 - 1] = Math.floor(bytes.length / 0x20000000);

  const state = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476];
  for (let block = 0; block < words.length; block += 16) {
    let [a, b, c, d] = state;
    for (let i = 0; i < 64; i++) {
      let f: number;
      let word: number;
      if (i < 16) {
        f = (b & c) | (~b & d);
        word = i;
      } else if (i < 32) {
        f = (d & b) | (~d & c);
        word = (5 * i + 1) % 16;
      } else if (i < 48) {
        f = b ^ c ^ d;
        word = (3 * i + 5) % 16;
      } else {
        f = c ^ (b | ~d);
        word = (7 * i) % 16;
      }
      const shift = SHIFTS[(i >> 4) * 4 + (i % 4)];
      const sum = (a + f + CONSTANTS[i] + words[block + word]) | 0;
      a = d;
      d = c;
      c = b;
      b = (b + ((sum << shift) | (sum >>> (32 - shift)))) | 0;
    }
    state[0] = (state[0] + a) | 0;
    state[1] = (state[1] + b) | 0;
    state[2] = (state[2] + c) | 0;
    state[3] = (state[3] + d) | 0;
  }

  const digest = new Uint8Array(16);
  const view = new DataView(digest.buffer);
  state.forEach((word, i) => view.setUint32(i * 4, word >>> 0, true));
  return digest;
}
